import AddUserReducer from '../features/settings/team/userSlices/AddUserSlice'
import LoginReducer  from "../features/user/userSlices/LoginSlice"
import LogoutReducer from '../features/settings/team/userSlices/LogoutSlice'
import UpdateUserReducer from '../features/settings/team/userSlices/EditUserSlice'
import addAdProductReducer from '../features/ads/adsSlices/addAdProductSlice';
import addAdReducer from '../features/ads/adsSlices/addAdSlice'
import addBannerReducer from '../features/banners/bannersSlices/addBannerSlice'
import addBrandReducer from '../features/brands/brandSlices/addBrandSlice';
import addCatalogueReducer from '../features/catalogues/catalogueSlices/addCatalogueSlice';
import addCategoryReducer from '../features/categories/categorySlices/addCategorySlice';
import addFeaturedCategoryReducer from '../features/featured-shops/featuredSlices/addFeaturedCategorySlice';
import addFeaturedProductReducer from '../features/featured-shops/featuredSlices/addFeaturedProductSlice';
import addFeaturedShopReducer from '../features/featured-shops/featuredSlices/addFeaturedShopSlice';
import addPriceReducer from '../features/prices/priceSlices/addPriceSlice'
import addProductReducer from '../features/products/productSlices/addProductSlice'
import addRetailerReducer from '../features/settings/retailers/retailerSlices/addRetailerSlice';
import addRoleReducer from '../features/roles/roleSlices/addRoleSlice';
import  addSupplierReducer from '../features/settings/suppliers/supplierSlices/addSupplierSlice'
import { configureStore } from '@reduxjs/toolkit';
import customerReducer from '../features/settings/customers/customerSlices/customerSlice';
import dashboardReducer from '../features/dashboard/dashboardSlices/dashboardSlice';
import deleteAdReducer from '../features/ads/adsSlices/deleteAdSlice'
import deleteBannerReducer from '../features/banners/bannersSlices/deleteBannerSlice'
import deleteBrandReducer from '../features/brands/brandSlices/deleteBrandSlice';
import deleteCatalogueReducer from '../features/catalogues/catalogueSlices/deleteCatalogueSlice';
import deleteCategoryReducer from '../features/categories/categorySlices/deleteCategorySlice';
import deleteFeaturedProductReducer from '../features/featured-shops/featuredSlices/deleteFeaturedProductSlice';
import deleteProductReducer from '../features/products/productSlices/deleteProductSlice';
import deleteRetailerReducer from '../features/settings/retailers/retailerSlices/deleteRetailerSlice';
import deleteRoleReducer from '../features/roles/roleSlices/deleteRoleSlice';
import  deleteSupplierReducer from '../features/settings/suppliers/supplierSlices/deleteSupplierSlice'
import editAdProductReducer from '../features/ads/adsSlices/editAdProductSlice';
import editAdReducer from '../features/ads/adsSlices/editAdSlice'
import editBannerReducer from '../features/banners/bannersSlices/editBannerSlice'
import editBrandReducer from '../features/brands/brandSlices/editBrandSlice';
import editCatalogueReducer from '../features/catalogues/catalogueSlices/editCatalogueSlice';
import editCategoryReducer from '../features/categories/categorySlices/editCategorySlice';
import editRetailerReducer from '../features/settings/retailers/retailerSlices/updateRetailerSlice'
import editReviewReducer from '../features/reviews/reviewSlices/editReviewSlice'
import featuredCategoriesReducer from '../features/featured-shops/featuredSlices/featuredCategoriesSlice';
import featuredProductStatusReducer from '../features/featured-shops/featuredSlices/featuredProductStatusSlice';
import featuredProductsReducer from '../features/featured-shops/featuredSlices/featuredProductsSlice';
import featuredShopReducer from '../features/featured-shops/featuredSlices/featuredShopSlice';
import getAdsReducer from '../features/ads/adsSlices/adSlice'
import getBannnersReducer from '../features/banners/bannersSlices/bannerSlice'
import getBrandReducer from '../features/brands/brandSlices/brandSlice'
import getCatalogueReducer  from '../features/catalogues/catalogueSlices/catalogueSlice'
import getCategoriesReducer from "../features/categories/categorySlices/categorySlice"
import getPricesReducer from '../features/prices/priceSlices/priceSlice'
import getProductsReducer from "../features/products/productSlices/productSlice";
import  getSubscriptionSlice  from "../features/subscriptions/subscriptionSlices/subscriptionSlice";
import getUsersReducer from "../features/settings/team/userSlices/userSlice"
import headerSlice from '../features/common/headerSlice';
import leadsSlice from '../features/leads/leadSlice';
import modalSlice from '../features/common/modalSlice';
import orderReducer from "../features/transactions/slices/orderSlice"
import orderStatusReducer from '../features/transactions/slices/orderStatusSlice';
import profileReducer from '../features/settings/profilesettings/slices/profileSlice';
import retailerReducer from '../features/settings/retailers/retailerSlices/retailerSlice';
import reviewsReducer from '../features/reviews/reviewSlices/reviewSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import roleReducer from '../features/roles/roleSlices/roleSlice'
import supplierReducer from '../features/settings/suppliers/supplierSlices/supplierSlice';
import updateFeaturedCategoryReducer from '../features/featured-shops/featuredSlices/updateFeaturedCategorySlice';
import updateFeaturedCategoryStatusReducer from '../features/featured-shops/featuredSlices/updateFeaturedCategoryStatusSlice';
import updateFeaturedProductReducer from '../features/featured-shops/featuredSlices/updateFeaturedProductSlice';
import updateFeaturedShopReducer from '../features/featured-shops/featuredSlices/updateFeaturedShopSlice';
import updateFeaturedShopStatusReducer from '../features/featured-shops/featuredSlices/updateFeaturedShopStatusSlice';
import updatePriceReducer from '../features/prices/priceSlices/updatePriceSlice'
import updateProductReducer from '../features/products/productSlices/updateProductSlice';
import updateRoleReducer from '../features/roles/roleSlices/editRoleSlice';
import  updateSupplierReducer from '../features/settings/suppliers/supplierSlices/updateSupplierSlice'

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  getProductsList: getProductsReducer,
  getUserList: getUsersReducer,
  categoryList : getCategoriesReducer,
  brandList : getBrandReducer,
  ordersList: orderReducer,
  authProfile: profileReducer,
  authUser : LoginReducer,
  addproducts : addProductReducer,
  addcategories: addCategoryReducer,
  logout : LogoutReducer,
  adduser : AddUserReducer,
  edituser: UpdateUserReducer,
  customerlist: customerReducer,
  supplierlist: supplierReducer,
  addsupplier: addSupplierReducer,
  editsupplier: updateSupplierReducer,
  deletesSupplier: deleteSupplierReducer,
  editcategory: editCategoryReducer,
  deletesCategory: deleteCategoryReducer,
  addbrands: addBrandReducer,
  editbrand: editBrandReducer,
  deletesBrand: deleteBrandReducer,
  updatingProduct: updateProductReducer,
  deletingProduct: deleteProductReducer,
  rolelist: roleReducer,
  addrole: addRoleReducer,
  editrole: updateRoleReducer,
  deleterole: deleteRoleReducer,
  dash: dashboardReducer,
  orderUpdate: orderStatusReducer,
  retailers:retailerReducer,
  addretailer: addRetailerReducer,
  editretailer:editRetailerReducer,
  prices: getPricesReducer,
  addprice: addPriceReducer,
  updateprice: updatePriceReducer,
  catalogueList : getCatalogueReducer,
  addcatalogues : addCatalogueReducer,
  editcatalogue : editCatalogueReducer,
  deletesCatalogue : deleteCatalogueReducer,
  bannerList : getBannnersReducer,
  addbanners : addBannerReducer,
  editbanner : editBannerReducer,
  deletesBanner : deleteBannerReducer,
  adList: getAdsReducer,
  addads : addAdReducer,
  editad : editAdReducer,
  deletesAd : deleteAdReducer,
  getFeaturedShopsList: featuredShopReducer,
  getFeaturedProductsList: featuredProductsReducer,
  getFeaturedCategoriesList: featuredCategoriesReducer,
  addFeaturedProduct: addFeaturedProductReducer,
  addFeaturedCategory: addFeaturedCategoryReducer,
  updateFeturedCaregory : updateFeaturedCategoryReducer,
  featuredCategoryStatus : updateFeaturedCategoryStatusReducer,
  addFeaturedShop: addFeaturedShopReducer,
  updateFeaturedShop: updateFeaturedShopReducer,
  featuredShopStatus: updateFeaturedShopStatusReducer,
  updatefeaturedproduct: updateFeaturedProductReducer,
  addadproduct : addAdProductReducer,
  editadproduct: editAdProductReducer,
  deletesretailer: deleteRetailerReducer,
  deletesfeaturedproduct: deleteFeaturedProductReducer,
  changefeaturedproductstatus: featuredProductStatusReducer,
  review: reviewsReducer,
  updatereview: editReviewReducer,
  subscriptions: getSubscriptionSlice
};

export default configureStore({
  reducer: combinedReducer,
});
